import React from 'react';
import { connect } from 'react-redux';
import { Placement } from '@noths/polaris-client-ribbons-design-system';
import dynamic from 'next/dynamic';

import { ModalLoader } from 'src/components/molecules/ModalLoader';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { AppThunkDispatch } from 'src/redux/store';
import type { CrossSellModalProps } from '../components/CrossSellModal';
import { actions } from '../modules';

const CrossSellModal = dynamic(
  async () =>
    (await import(/* webpackChunkName: "CrossSellModal" */ '../components/CrossSellModal'))
      .CrossSellModal,
  { loading: () => <ModalLoader />, ssr: false },
);

type StateProps = Pick<CrossSellModalProps, 'isOpen' | 'placementTitle'>;
type DispatchProps = Pick<CrossSellModalProps, 'onModalClose' | 'onContinueToCart'>;

const mapStateToProps = ({ crossSell, richRelevance }: ReduxApplicationState): StateProps => ({
  placementTitle: richRelevance[Placement.CrossSell].placementTitle!,
  isOpen: crossSell.isOpen,
});

const mapDispatchToProps = (
  dispatch: AppThunkDispatch,
  props: Pick<DispatchProps, 'onModalClose'>,
): DispatchProps => ({
  onModalClose: () => {
    props.onModalClose();
    dispatch(actions.closeModal());
  },
  onContinueToCart: () => {
    dispatch(actions.onContinueToCart());
  },
});

export const CrossSellModalContainer = connect(mapStateToProps, mapDispatchToProps)(CrossSellModal);
